<template>
	<div class="problemHome">
		<div class="title">
			{{ $t("exam_student_result.title") }}
		</div>
        <a-spin :spinning="isLoading">
		<div class="problem-main" style="margin-top: 0px;">
			<div class="problem-detail">
<!--				<h2>5.4</h2>-->
				<div class="filter-data">
					<div class="pb-2 border-bottom filter-option">
						<div class="filter-search-input">
							<b-input-group>
								<b-input-group-prepend is-text>
									<b-icon icon="search"></b-icon>
								</b-input-group-prepend>
								<b-input
										:placeholder="$t('exam_student_result.label.search')"
										v-model="fillterData.search"
										@change="changeSearch"
								></b-input>
							</b-input-group>
						</div>

                        <div class="col-4 d-flex">
                            <b-form-select
                                style="font-size: 14px;"
                                selectLabel="√"
                                track-by="id"
                                label="name"
                                @change="handleChangeBusiness"
                                class="col-9 filter-dropdown"
                                :options="convertBusiness"
                                v-model="businessSelected"
                            >
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        {{ $t("myExam.label.b2b_option_branch_default") }}
                                    </b-form-select-option>
                                    <b-form-select-option :value="-1">
                                    {{ $t("myExam.label.business_is_null") }}
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>
						<div style="margin-right: 10px">
							<a-range-picker
									v-model="datePicker"
									:format="dateFormat"
									separator="->"
									:placeholder="[$t('myExam.label.tryExam_startDate'),$t('myExam.label.tryExam_endDate')]"
									@change="handleChangeDatePicker"
							/>
						</div>
                        <div>
                            <a-button class="d-flex align-items-center" type="primary" :loading="iconLoading" icon="download" :size="'default'"
                                @click="exportStudentResult"
                            >
                                Excel
                            </a-button>
                        </div>
					</div>

					<div class="problem-table-content">
						<b-table
								hover
								class="mt-4 table-detail-data"
								id="my-table"
								:items="listData"
								:fields="fields"
								small
						>
							<template #cell(id)="row">
								<div>{{row.index + 1 +(pagination.current_page - 1) * pagination.per_page}}</div>
							</template>
							<template v-slot:head()="row">
								<p style="color: #A0AEC0;">{{ $t(row.label) }}</p>
							</template>
							<template #cell(exam_name)="row">
								<div v-b-tooltip.hover.topleft :title="row.item.exam_name">
									{{ row.item.exam_name }}
								</div>
							</template>
							<template #cell(student_name)="row">
								<div v-b-tooltip.hover.topleft :title="row.item.student_name">
									{{ row.item.student_name }}
								</div>
							</template>
							<template #cell(date)="row">
									{{ moment(row.item.created_at).format(`DD/MM/YYYY`)}}
							</template>
							<template #cell(total_of_mark)="row">
									{{ row.item.total_of_mark }}
							</template>
							<template #cell(total_of_score)="row">
									{{ row.item.total_of_score }}
							</template>
							<template #cell(total_question)="row">
									{{ row.item.count_question }}
							</template>
							<template #cell(number_right_answer)="row">
									{{ row.item.answer_correct }}
                            </template>
							<template #cell(grade)="row">
									{{ row.item.grade === -1 ? $t("exam_student_result.label.no_grade") : row.item.grade }}
							</template>
                            <template #cell(duration)="row">
									{{ Math.floor(row.item.duration / 60) }}:{{ (row.item.duration - Math.floor(row.item.duration / 60) * 60).toLocaleString('en-US',{minimumIntegerDigits: 2, useGrouping: false}) }} / {{ row.item.time_do_exam }}:00
							</template>
                            <template #cell(pass_score)="row">
                                <span v-if="row.item.pass_score_status == 0" style="color: #ec0000">{{$t('exam_student_result.label.pass_score_lable0')}}</span>
                                <span v-else-if="row.item.pass_score_status == 1">{{$t('exam_student_result.label.pass_score_lable1')}}</span>
                                <span v-else-if="row.item.pass_score_status == 2" style="color: #00CC00">{{$t('exam_student_result.label.pass_score_lable2')}}</span>
                            </template>
                            <template #cell(action)="row">
								<b-icon title="Xem bài làm chi tiết" @click="toTryExam(row.item)" class="h4" style="cursor: pointer;" icon="eye-fill" variant="info"></b-icon>
                            </template>
						</b-table>
					</div>

                    <div class="d-flex py-4 px-2">
                        <div class="col-12 col-md-8 d-flex align-items-center">
                            <div class="col-6 p-0 d-flex align-items-center">
                                <b-input
                                    class="col-4 col-md-3 mr-1 mw-50"
                                    type="number"
                                    placeholder=""
                                    @change="getDataSubmit"
                                    v-model="fillterData.selected.paginate"
                                >
                                </b-input>
                                bản ghi/Trang
                            </div>
                            <div class="col-6 p-0 d-flex align-items-center justify-content-end justify-content-lg-center">
                                Đến trang
                                <b-input
                                    @change="getDataSubmit"
                                    class="col-4 col-md-3 ml-1 mw-50"
                                    type="number"
                                    placeholder=""
                                    v-model="fillterData.page"
                                >
                                </b-input>

                            </div>
                        </div>

                        <div class="col-12 col-md-4 d-flex align-items-center justify-content-end">
                            <b-pagination
                                :key="`${pagination.current_page}_${pagination.total}_${pagination.per_page}`"
                                @change="change"
                                :value="pagination.current_page"
                                :total-rows="pagination.total"
                                :per-page="pagination.per_page"
                                aria-controls="my-table"
                                class="mt-3"
							></b-pagination>
                        </div>

                    </div>


				</div>
			</div>
		</div>
        </a-spin>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from 'moment-timezone';
import Cookies      from "js-cookie";
import router       from "@/router";

export default {
	components: {
	},
	data() {
		return {
            iconLoading: false,
            isLoading: false,
			dateFormat: 'YYYY/MM/DD',
			datePicker: [],
			dateFrom: '',
			dateTo: '',
            business_id: '',
			fillterData: {
				search: "",
				page: 1,
				selected: {
					paginate: 20,
				}
			},
			userSelected: {
				roleSelected: null,
				nationSelected: null,
				statusSelected: null
			},
			user: {
				status: [
					{value: 1, text: "Hoàn thành"},
					{value: 0, text: "Chưa hoàn thành"},
				],
			},
			fields: [
				{
					key: "id",
					label: "paperslist.label.stt",
					sortDirection: "desc",
					class: "text-center px-3 "
				},
				{
					key: "exam_name",
					label: "exam_student_result.label.nameExam",
					class: ""
				},
				{
					key: "student_name",
					label: "exam_student_result.label.student_name",
					class: "tb-userName"
				},
				{
					key: "date",
					label: "exam_student_detail.submit_date",
					sortDirection: "desc",
					class: ""
				},
				{
					sortable: true,
					key: "total_of_mark",
					label: "exam_student_result.label.total_mark",
					sortDirection: "desc",
					class: "text-center "
				},
				{
					sortable: true,
					key: "total_of_score",
					label: "exam_student_result.label.total_score",
					sortDirection: "desc",
					class: "text-center "
				},
				{
					key: "total_question",
					label: "exam_student_result.label.total_question",
					sortDirection: "desc",
					class: "text-center"
				},
				{
					key: "number_right_answer",
					label: "exam_student_result.label.number_right_answer",
					class: "tb-email text-center"
				},
				{
					key: "grade",
					label: "exam_student_result.label.grade",
					sortDirection: "desc",
					class: "text-center tb-roles"
				},
				{
					key: "duration",
					label: "exam_student_result.label.time",
					sortDirection: "desc",
					class: "text-center tb-roles"
				},
                {
                    key: "pass_score",
                    label: "exam_student_result.label.pass_score_title",
                    class: "tb-email text-center"
                },
                {
                    key: "action",
                    label: "",
                    class: "tb-email text-center",
                },
			],
			listData: [],
            businessSelected: null,
            listDataBusiness: [],
            convertBusiness: [],
		};
	},
	computed: {
		...mapGetters({
			pagination: "exam/pagination",
			getSubmitExam: "exam/getSubmitExamRes",
            listBusiness: "category/business",
		}),
	},
	async created() {
		await this.getDataSubmit();
		moment.tz.setDefault('Etc/Zulu');
        await this.getBusiness();
       // console.log(this.listDataBusiness);
       for (let i = 0; i < this.listDataBusiness.length; i++) {
			this.convertBusiness.push({
				value: this.listDataBusiness[i].id,
				text: this.listDataBusiness[i].name,
			});
		};
	},
	methods: {
        toTryExam(record){
            Cookies.set("idResultExam", record.id);
            Cookies.set("idExam", record.exam_id);
            Cookies.set("typeExam", "result");

            //router.push(`/admin/exam/student-result-detail?${record.exam_id}&${record.exam_name.replace(/ /g, "-")}`);
            const route = this.$router.resolve({
                path: `/admin/exam/student-result-detail?${record.exam_id}&${record.exam_name.replace(/ /g, "-")}`
            });

            window.open(route.href, "_blank");
        },
		async getDataSubmit() {
			const params = {
				keyword: this.fillterData.search,
				from: this.dateFrom,
				to: this.dateTo,
				page: this.fillterData.page,
                perPage: this.fillterData.selected.paginate,
                business_id: this.business_id
			};
            this.isLoading=true;
			await this.$store.dispatch("exam/getSubmitExam", params);
			this.listData = this.getSubmitExam.data;
            this.isLoading=false;
		},
		moment,
		change: function (page) {
			this.fillterData.page = page;
			this.getDataSubmit();
		},
        changeSearch(){
            this.fillterData.page = 1;
            this.getDataSubmit();
        },
		handleChangeDatePicker(value) {
            this.fillterData.page = 1;
			this.datePicker = value;
			this.dateFrom = value[0] ? moment(value[0]?._d).format("YYYY/MM/DD") : null;
			this.dateTo = value[1] ? moment(value[1]?._d).add(1, 'days').format("YYYY/MM/DD") : null;
			this.getDataSubmit();
		},

        handleChangeBusiness(business){
           // console.log(business);
            this.fillterData.page = 1;
            this.business_id = business;
            this.getDataSubmit();
        },

        async getBusiness() {
            await this.$store.dispatch("category/getBusiness");
            this.listDataBusiness = this.listBusiness;
        },

        async exportStudentResult(){
            this.iconLoading = true;
            const params = {
				keyword: this.fillterData.search,
				from: this.dateFrom,
				to: this.dateTo,
				page: 1,
                perPage: 20000,
                business_id: this.business_id
			};
            await this.$store.dispatch("exam/exportStudentResult", params);

            if (this.$store.state.exam.statusExport === 200) {
                this.iconLoading = false;
            }else{
                this.iconLoading = false;
                    this.$root.toast(
                    "Notification",
                    "danger",
                    this.$store.state.exam.statusExport.message
                    );
            }
        },
	},
};
</script>

<style>
@import "../../assets/scss/TeacherList.scss";
@import "../../assets/scss/ExamCommon.scss";
.ant-calendar-picker-input, .filter__data-selector{
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
	border: none !important;
}
.title {
	font-weight: bold;
	font-size: 25px;
	color: #0770ab;
	text-align: left;
	margin-bottom: 15px;
	margin-top: 15px;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
	"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
	"Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.ant-btn i{
    font-size: 20px;
}
.anticon-loading{
    margin-left: 0 !important;
}
</style>
